import {
  FETCH_CAR_TYPES,
  FETCH_CAR_TYPES_SUCCESS,
  FETCH_CAR_TYPES_FAILED,
  EDIT_CAR_TYPE
} from "../store/types";
import { language, cloud_function_server_url } from '../../config';

const END_POINT = `${cloud_function_server_url}/cars`;

export const fetchCarTypes = () => (dispatch) => (firebase) => {

  dispatch({
    type: FETCH_CAR_TYPES,
    payload: null
  });

  fetch(`${END_POINT}/fetch-car-types`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    // body: JSON.stringify(tblData)
  })
    .then(async (res) => {
      const response = await res.json();
      const data = response.data;
      dispatch({
        type: FETCH_CAR_TYPES_SUCCESS,
        payload: data
      });
    }).catch(error => {
      console.log("res check error", error)
      dispatch({
        type: FETCH_CAR_TYPES_FAILED,
        payload: language.no_cars
      });
    });
};

export const addCarType = (tblData, boundary) => (dispatch) => async (firebase) => {
  dispatch({
    type: EDIT_CAR_TYPE,
    payload: tblData
  });

  fetch(`${END_POINT}/add-car-type`, {
    method: 'POST',
    body: tblData
  })
    .then(async (res) => {
      const response = await res.json();
      console.log("response", response)
      dispatch({
        type: EDIT_CAR_TYPE,
        payload: null
      });
      fetchCarTypes()(dispatch)(firebase)
    }).catch(error => {
      console.log("res check error", error)
      dispatch({
        type: EDIT_CAR_TYPE,
        payload: error
      });
    });
}

export const editCarType = (oldData, tblData) => (dispatch) => async (firebase) => {

  dispatch({
    type: EDIT_CAR_TYPE,
    payload: tblData
  });

  fetch(`${END_POINT}/update-car-type/${oldData._id}`, {
    method: 'PUT',
    body: tblData
  })
    .then(async (res) => {
      const response = await res.json();
      console.log("response", response)
      dispatch({
        type: EDIT_CAR_TYPE,
        payload: null
      });
      fetchCarTypes()(dispatch)(firebase)
    }).catch(error => {
      console.log("EDIT_CAR_TYPE", error)
      dispatch({
        type: EDIT_CAR_TYPE,
        payload: error
      });
    });
}

const uploadFile = (oldData, tblData, singleCarTypesRef, dispatch) => {
  let editedVehicle = tblData;
  delete editedVehicle.id;
  singleCarTypesRef(oldData.id).set(editedVehicle).then(() => {
    dispatch({
      type: EDIT_CAR_TYPE,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: EDIT_CAR_TYPE,
      payload: error
    });
  });
}

export const deleteCarType = (id) => (dispatch) => (firebase) => {
  dispatch({
    type: EDIT_CAR_TYPE,
    payload: id
  });

  fetch(`${END_POINT}/delete-car-type/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then(async (res) => {
      const response = await res.json();
      console.log("response", response)
      dispatch({
        type: EDIT_CAR_TYPE,
        payload: null
      });
      fetchCarTypes()(dispatch)(firebase)
    }).catch(error => {
      console.log("EDIT_CAR_TYPE", error)
      dispatch({
        type: EDIT_CAR_TYPE,
        payload: error
      });
    });
}